import SectionHeader from './SectionHeader';
import type { Section, SectionAction } from '../types';
import { useSectionTitle } from '../hooks/useSectionTitle';
import { getSectionActions } from '../utils/getSectionActions';

type Props = {
  section: Section;
  onActionClick?: (action: SectionAction) => void;
};

/** Section chrome with optional title lifted from the sole metric/insight display_name. */
export default function SectionHeaderWithTitle({ section, onActionClick }: Props) {
  const title = useSectionTitle(section);
  const actions = getSectionActions(section);

  return (
    <SectionHeader
      overline={section.overline}
      title={title}
      subtitle={section.subtitle}
      aside={section.aside}
      actions={actions}
      onActionClick={onActionClick}
    />
  );
}
